import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { checkAuth } from '../../api/axios'; 
import LoadingSpinner from '../../components/LoadingSpinner';

const PrivateRoute: React.FC = () => {
  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {
    async function verify() {
      const authenticated = await checkAuth();
      setIsAuth(authenticated);
    }
    verify();
  }, []);

  if (isAuth === null) {
    return <LoadingSpinner />; 
  }

  return isAuth ? <Navigate to="/users" /> : <Outlet />;
};

export default PrivateRoute;
